module.exports = __webpack_public_path__ + "img/3_of_Diamonds.svg.e93d2a3f.png";